import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb8bb3e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "select-container",
  ref: "selectRef"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = ["disabled", "aria-labelledby", "aria-label", "aria-expanded", "aria-disabled", "onKeydown"]
const _hoisted_5 = { "aria-live": "polite" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          id: $setup.selectLabelId
        }, [
          _createElementVNode("span", null, _toDisplayString($props.label), 1 /* TEXT */),
          ($props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createElementVNode("button", {
      ref: "selectButtonRef",
      type: "button",
      class: _normalizeClass(["select", { disabled: !$props.filter?.availableOptions.length || $props.disabled }]),
      disabled: !$props.filter?.availableOptions.length || $props.disabled,
      "aria-labelledby": $props.label ? $setup.selectLabelId : undefined,
      "aria-label": !$props.label && $props.ariaLabel ? $props.ariaLabel : undefined,
      "aria-haspopup": 'listbox',
      "aria-expanded": $setup.showOptions ? 'true' : 'false',
      "aria-disabled": 
        !$props.filter?.availableOptions.length || $props.disabled ? 'true' : 'false'
      ,
      role: "button",
      tabindex: "0",
      onClick: $setup.handleShowOptions,
      onKeydown: [
        _withKeys(_withModifiers($setup.handleShowOptions, ["prevent"]), ["enter"]),
        _withKeys(_withModifiers($setup.handleShowOptions, ["prevent"]), ["space"])
      ]
    }, [
      _createElementVNode("p", _hoisted_5, _toDisplayString($setup.selectedOption.displayText ?? $setup.selectedOption.name), 1 /* TEXT */),
      _createVNode($setup["InlineSvg"], {
        class: _normalizeClass(["down-arrow-icon", { disabled: !$props.filter?.availableOptions.length || $props.disabled }]),
        src: require('@/assets/icons/chevron-down.svg'),
        "aria-hidden": "true",
        alt: ""
      }, null, 8 /* PROPS */, ["class", "src"])
    ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4),
    (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
      ($setup.showOptions)
        ? (_openBlock(), _createBlock($setup["SelectModal"], {
            key: 0,
            contents: $setup.optionNames,
            initialIndex: $setup.selectedOptionIndex,
            onHideModal: $setup.handleHideOptions,
            onOnItemSelected: $setup.onClickOption
          }, null, 8 /* PROPS */, ["contents", "initialIndex"]))
        : _createCommentVNode("v-if", true)
    ]))
  ], 512 /* NEED_PATCH */))
}